import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { VociActions } from './voci.actions';
import { VociPort } from '../../core/services/voci/voci.port';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { PreventiviActions } from '../preventivi/preventivi.actions';
import { SwalService } from '../../core/services/alerts/swal.service';

@Injectable()
export class VociEffects {
  private actions$ = inject(Actions);
  private api = inject(VociPort);
  private swalService = inject(SwalService);

  loadByCapitoloId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.loadByCapitoloId),
      switchMap(({ idCapitolo }) =>
        this.api.getByCapitoloId(idCapitolo).pipe(
          map((items) => VociActions.loadByCapitoloIdSuccess({ items })),
          catchError((err) =>
            of(VociActions.loadByCapitoloIdFailure({ error: err?.message ?? 'Errore caricamento' }))
          )
        )
      )
    )
  );

  loadDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.loadDetails),
      switchMap(({ id }) =>
        this.api.getById(id).pipe(
          map((item) => VociActions.loadDetailsSuccess({ item })),
          catchError((err) =>
            of(VociActions.loadDetailsFailure({ error: err?.message ?? 'Errore dettagli' }))
          )
        )
      )
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.create),
      switchMap(({ dto, idPreventivo }) =>
        this.api.create(dto).pipe(
          map((id) => VociActions.createSuccess({ id: Number(id), idPreventivo })),
          catchError((err) =>
            of(VociActions.createFailure({ error: err?.message ?? 'Errore creazione' }))
          )
        )
      )
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.update),
      switchMap(({ id, changes, idPreventivo }) =>
        this.api.update(id, changes).pipe(
          map((returnedId) => VociActions.updateSuccess({ id: Number(returnedId), idPreventivo })),
          catchError((err) =>
            of(VociActions.updateFailure({ error: err?.message ?? 'Errore modifica' }))
          )
        )
      )
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.delete),
      switchMap(({ id, idPreventivo }) =>
        this.api.delete(id).pipe(
          map(() => VociActions.deleteSuccess({ id, idPreventivo })),
          catchError((err) =>
            of(VociActions.deleteFailure({ error: err?.message ?? 'Errore eliminazione' }))
          )
        )
      )
    )
  );

  deleteSuggestion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.deleteSuggestion),
      switchMap(({ id }) =>
        this.api.deleteSuggestion(id).pipe(
          map(() => VociActions.deleteSuggestionSuccess({ id })),
          catchError((err) =>
            of(VociActions.deleteSuggestionFailure({ error: err?.message ?? 'Errore rimozione suggerimento' }))
          )
        )
      )
    )
  );
/*
  refreshPreventivoDetailsAfterMutations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.createSuccess, VociActions.updateSuccess, VociActions.deleteSuccess),
      map(({ idPreventivo }) => PreventiviActions.loadDetails({ id: idPreventivo }))
    )
  );*/

  refreshCapitoliAfterVociMutation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VociActions.createSuccess, VociActions.updateSuccess, VociActions.deleteSuccess),
      map(({ idPreventivo }) => PreventiviActions.loadCapitoli({ idPreventivo }))
    )
  );

  showMutationSuccessToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(VociActions.createSuccess, VociActions.updateSuccess, VociActions.deleteSuccess),
        tap((action) => {
          switch (action.type) {
            case VociActions.createSuccess.type:
              this.swalService.success('Voce aggiunta con successo!');
              return;
            case VociActions.updateSuccess.type:
              this.swalService.success('Voce modificata con successo!');
              return;
            case VociActions.deleteSuccess.type:
              this.swalService.success('Voce eliminata con successo!');
              return;
          }
        })
      ),
    { dispatch: false }
  );

  showMutationFailureToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(VociActions.createFailure, VociActions.updateFailure, VociActions.deleteFailure),
        tap(({ error }) => this.swalService.error(error || 'Operazione voce non riuscita'))
      ),
    { dispatch: false }
  );
}
